import gql from 'graphql-tag';

export const USER_FRAGMENT = gql`
  fragment User on User {
    id
    name
    email
    country
  }
`;

export const USER_INVITE_FRAGMENT = gql`
  fragment UserInvite on UserInvite {
    email
    name
    status
    registered
    invitedBy
    orphaned
  }
`;

export const FRAGMENT_ONBOARDING_STAGE = gql`
  fragment UserOnboardingStage on UserOnboardingStage {
    name
    status
    value
  }
`;

export const FRAGMENT_BOOKMARK = gql`
  fragment Bookmark on Bookmark {
    id
    type
    name
    link
    metadata
  }
`;

export const FRAGMENT_USER_SETTINGS = gql`
  fragment UserSettings on UserSettings {
    extensionCustomerId
    extensionWorkspaceId
  }
`;
